import React, { useEffect, useState } from 'react';
import { useUser } from '../../contexts/UserContext'; 
import { SiFacebook } from 'react-icons/si';

const FacebookBtn = ({ disabled = false , mode='login', showAlert}) => {
  const [authCode, setAuthCode] = useState(null);
  const { socialLogin } = useUser();

  const handleFacebookLogin = () => {
    const clientId = process.env.REACT_APP_FACEBOOK_CLIENT_ID;
    const redirectUri = encodeURIComponent("https://www.doroosonline.co.il/api/facebook-redirect.php");
    const scope = "public_profile,email";

    const oauthUrl = `https://www.facebook.com/v18.0/dialog/oauth?client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}`;

    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;

    // Open OAuth dialog in a maximized popup window
    const popupWindow = window.open(
        oauthUrl,
        '_popup',
        `width=${screenWidth}, height=${screenHeight}, left=0, top=0`
    );

    if (!popupWindow || popupWindow.closed || typeof popupWindow.closed === "undefined") {
      showAlert("נא לאפשר פופ-אפ בדפדפן כדי להתחבר באמצעות פייסבוק.");
    }
  };

  const getCookie = (name) => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  };

  const setCookie = (name, value, minutes) => {
    if (!name || !value) return;
    let expires = '';
    if (minutes) {
      const date = new Date();
      date.setTime(date.getTime() + minutes * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = `${name}=${value}${expires}; path=/; domain=.doroosonline.co.il; Secure; SameSite=Lax`;
  };

  useEffect(() => {
   
    const interval = setInterval(() => {
      const code = getCookie("facebook_auth_code");
      const lastCode = getCookie("last_facebook_auth_code");

      if (code && code !== lastCode) {
        setAuthCode(code);
        setCookie("last_facebook_auth_code", code, 30);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const doFacebookLogin = async () => {

      if (!authCode) return;

      try {
        const response = await fetch(`https://www.doroosonline.co.il/api/facebook-callback.php?code=${authCode}`);
        const data = await response.json();

        if (!data.success) {
          throw new Error(data.error || "Facebook login failed.");
        }

        const { f_id, name, email, picture } = data.user;

        const payload = {
          fullName:name,
          email,
          picture,
          password: f_id, 
          auth: "FACEBOOK",
        };
        
        await socialLogin(mode, payload);

      } catch (err) {
        showAlert(err.message);
      }
    };

    doFacebookLogin();
  }, [authCode]);

  return (
    <button
      onClick={handleFacebookLogin}
      disabled={disabled}
      className="w-full flex items-center justify-center gap-2 py-3 px-4 bg-[#1877F2] text-white rounded-lg shadow-sm hover:shadow-md"
    >
      <SiFacebook className="w-5 h-5" />
      התחבר באמצעות פייסבוק
    </button>
  );
};

export default FacebookBtn;
